import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { IBranchListByNaCodeAndPackage } from "src/app/interfaces/branchList-by-naCode-Package";

@Injectable({
  providedIn: "root"
})
export class EducationPackageService {
  constructor(private core: CoreService) { }

  getList(page: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.educationPackage.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getListByMaster(nationalCode: number = null, page: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.educationPackage.listMaster + nationalCode,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.educationPackage.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: IEducationPackage): Observable<any> {
    return this.core.post(
      ServiceRoute.educationPackage.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IEducationPackage) {
    return this.core.put(
      ServiceRoute.educationPackage.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any) {
    return this.core.delete(
      ServiceRoute.educationPackage.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  getBranchListByNationalCodeAndPackage(
    data: IBranchListByNaCodeAndPackage
  ): Observable<any> {
    return this.core.post(
      ServiceRoute.educationPackage.GetBranchListByNationalCodeAndPackage,
      data,
      new CommonHttpOption().headers
    );
  }
}
